import React from 'react';
import { OrderBookRowFieldProps } from '../../../types';

const OrderBookSideTotal = (props: OrderBookRowFieldProps) => {
  return <span className="total-text">{props.total.toPrecision(5)}</span>;
};

export default OrderBookSideTotal;
